import { Client } from './core.js';
export const configure = fn => {
  return options => {
    return fn(new Client(options), options);
  };
};